
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    msg: String,
    locationId: String,
  },
})

export default class HelloWorld extends Vue {
  msg!: string;

  locationId!: string;
}
